module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"title":"評論排序標準"}}')
  delete Component.options._Ctor
}
